import { lazy } from 'react';

const ProjectPipelinePage = lazy(() => import('./ProjectPipelinePage'));

const ProjectPipelineConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: 'projectPipeline',
            element: <ProjectPipelinePage />,
        },
    ],
};

export default ProjectPipelineConfig;